import { CORE_ABILITY_SLUGS, normalizeAbilitySlug } from '../data/abilityPapers';
import { clampAbilityScore } from './abilityVectorDisplay';

/**
 * @param {string} chapterSlug
 * @param {{ totalScore?: number, ability?: number[] } | null | undefined} apiResponse
 */
export function buildChapterResult(chapterSlug, apiResponse) {
  if (!chapterSlug) return null;
  const slug = normalizeAbilitySlug(chapterSlug);
  const dimensionIndex = CORE_ABILITY_SLUGS.indexOf(slug);
  const ability = apiResponse?.ability;
  let dimensionScore = null;
  if (dimensionIndex >= 0 && Array.isArray(ability) && ability.length > dimensionIndex) {
    const parsed = Number(ability[dimensionIndex]);
    dimensionScore = Number.isFinite(parsed) ? clampAbilityScore(parsed) : null;
  }
  const totalScore = Number.isFinite(Number(apiResponse?.totalScore))
    ? Number(apiResponse.totalScore)
    : null;
  if (dimensionScore == null && totalScore == null) return null;
  return {
    chapterSlug: slug,
    dimensionIndex,
    dimensionScore,
    totalScore,
    abilityVector: Array.isArray(ability) ? ability : null
  };
}
